import type { Module, Product, Section, Track } from '@space-shell/common/services/sections'
import { SectionType } from '@space-shell/common/services/sections'
import { useAppStore } from '@space-shell/core/store'
import LearningTrackCard from '@space-shell/modules/learningTrack/components/learningTrackCard'
import ModuleCard from '@space-shell/modules/module/components/moduleCard'
import ProductCard from '@space-shell/modules/products/components/productCard'

type ItemCardProps = {
  item: Module | Track | Product
  section: Section
  isProductCard: boolean
}

const ItemCard = ({ item, section, isProductCard }: ItemCardProps) => {
  const { isPreview } = useAppStore()

  if (
    isProductCard ||
    section.type === SectionType.PURCHASED ||
    section.type === SectionType.SALE
  ) {
    return (
      <ProductCard
        product={item as Product}
        isPreview={isPreview}
        sectionId={section.id}
        orientation={section.orientation}
      />
    )
  }

  if (section.type === SectionType.MODULE) {
    return (
      <ModuleCard
        module={item as Module}
        sectionId={section.id}
        productId={section.entityId}
        isPreview={isPreview}
      />
    )
  }

  if (section.type === SectionType.TRACK) {
    return (
      <LearningTrackCard
        track={item as Track}
        isPreview={isPreview}
        sectionId={section.id}
        productId={section.entityId}
      />
    )
  }

  return null
}

export default ItemCard
